// Module
var code = "<div class=\"content-element [[ marginTop ? '-m-top-' + marginTop : '' ]] [[ marginBottom ? '-m-bottom-' + marginBottom : '' ]]\"> </div>";
// Exports
export default code;